var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTickCircle = function SvgTickCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "current",
    d: "M8 15.166A7.173 7.173 0 0 1 .835 8 7.173 7.173 0 0 1 8.001.833 7.173 7.173 0 0 1 15.167 8a7.173 7.173 0 0 1-7.166 7.166M8 1.833A6.174 6.174 0 0 0 1.835 8c0 3.4 2.767 6.166 6.167 6.166S14.167 11.4 14.167 8s-2.766-6.167-6.166-6.167"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "current",
    d: "M7.053 10.387a.5.5 0 0 1-.353-.147L4.813 8.353a.503.503 0 0 1 0-.706.503.503 0 0 1 .707 0L7.053 9.18l3.427-3.427a.503.503 0 0 1 .706 0 .503.503 0 0 1 0 .707l-3.78 3.78a.5.5 0 0 1-.353.147"
  })));
};
export default SvgTickCircle;